import React, {useRef, useState, useEffect} from 'react';
import Spinner from '../../../../common/Spinner/Spinner';
import {
  Container,
  ContentArea,
  ListContent,
  ListContentKey,
  ListContentRow,
  ListContentValue,
  TaxableAmount,
  TaxableAmountLft,
  TaxableAmountRht,
} from './CommissionBreakup.syles';

const CommissionBreakup = ({edit, listData, breakupData}) => {
  const {heading, taxableAmount, commsionBreakupListData} = breakupData;

  const inputRef = useRef();

  const [inputVal, setInputVal] = useState(taxableAmount?.value);
  const [isLoading, setIsLoading] = useState(false);

  const [editable, setEditable] = useState(true);

  const handleInput = e => setInputVal(e.target.value);

  const handleEdit = () => {
    setEditable(!editable);
    inputRef.current.focus();
  };

  const handleBlur = () => {};

  return (
    <Container>
      {heading && <h3>{heading}</h3>}
      <ContentArea>
        {taxableAmount && (
          <TaxableAmount>
            <TaxableAmountLft>
              <p className="fs20 latoBlack blackText">{taxableAmount?.title}</p>
            </TaxableAmountLft>
            <TaxableAmountRht>
              <div className="inputWrap">
                {/*isLoading && (
                  <span className="inputLoader">
                    <Spinner />
                  </span>
                )*/}
                <input
                  ref={inputRef}
                  readOnly={editable}
                  type="text"
                  className="textInput"
                  value={'₹ ' + taxableAmount?.value}
                  onChange={handleInput}
                  onBlur={handleBlur}
                />
              </div>
              {!edit && (
                <a onClick={handleEdit} className="edit">
                  {edit}
                </a>
              )}
            </TaxableAmountRht>
          </TaxableAmount>
        )}
        {commsionBreakupListData?.length && (
          <ListContent>
            {commsionBreakupListData.map((item, idx) => (
              <ListContentRow key={idx}>
                <ListContentKey>{item?.title}</ListContentKey>
                <ListContentValue>
                  {item?.type === 'currency' && '₹ '}
                  {item?.value}
                </ListContentValue>
              </ListContentRow>
            ))}
          </ListContent>
        )}
      </ContentArea>
    </Container>
  );
};

export default CommissionBreakup;
